// extracted by css-extract-rspack-plugin
export default {"categories":"CUt_i","link":"XYlSo","icon":"K3AZG"};